export * from './resizable.module';
export { ResizableDirective as Resizable } from './resizable.directive';
export { ResizeHandleDirective as ResizeHandle } from './resize-handle.directive';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-resizable-element/dist/esm/src/index.js
// module id = ./node_modules/angular-resizable-element/dist/esm/src/index.js
// module chunks = 3